import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DonutKpiDataObject, type DonutKpiState } from '../../types'

const initialState: DonutKpiState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const totalReadsDonutSlice = createSlice({
  name: 'totalReadsDonut',
  initialState,
  reducers: {
    totalReadsDonutLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    totalReadsDonutUpdateAction: (state, action: PayloadAction<{ data: DonutKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    totalReadsDonutErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    }
  }
})

export const {
  totalReadsDonutLoadingAction,
  totalReadsDonutUpdateAction,
  totalReadsDonutErrorAction
} = totalReadsDonutSlice.actions

export default totalReadsDonutSlice.reducer
